import { FieldError } from './field-error';

export class ApiError {
    httpStatus: string;
    message: string;
    fieldErrors: FieldError[];
}